import {Fireworks} from "../utils/Fireworks";
import {Button, Divider, Paper, Typography} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {post} from "../utils/post";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {FList} from "./FList";
import {storage} from "../utils/localstorage";
import {AppComponent} from "../App";
import Link from '@mui/material/Link';
import {Courses} from "./Courses";


const TrialCongratulations = () => {
    const onClick = () => {
        AppComponent.setRestriction(null)
    }

    return (
        <>
            <Fireworks/>
            <Typography variant="h3" align={"center"}>
                Поздравляем!
            </Typography>
            <Typography variant="h4" align={"center"}>
                Вы на правильном пути!
            </Typography>
            <Typography variant="h5" align={"center"}>
                Вам предоставлено 7 дней бесплатного периода
            </Typography>
            <Typography variant="h6" align={"center"}>
                После 7 дней можете бесплатно продолжить с ограниченным функционалом или подписаться на платный тариф со
                всеми возможностями
            </Typography>
            <Typography variant="h2" align={"center"}>
                <Button id={"goToProblems"} onClick={onClick} size={"large"} variant="contained">
                    Отлично
                </Button>
            </Typography>
        </>
    )
}

export const ShouldTrial =  ({items}) => {
    const [congratulations, setCongratulations] = useState(false);
    const [courses, setCourses] = useState([]);

    const onStartTrial = async () => {
        await post({method: "trialStart", courses}, true);
        setCongratulations(true);
    }

    if (congratulations) {
        return <TrialCongratulations/>
    }

    const {displayName} = storage("authData");

    return (
        <Paper elevation={3} sx={{p: 2}}>
            <Typography variant="h5">
                Привет, {displayName}
            </Typography>
            <FList/>

            <Courses items={items} onChange={setCourses}/>

            <Button id={"startTrialButton"}
                    onClick={onStartTrial}
                    fullWidth={true}
                    size={"large"}
                    variant="contained"
                    color="primary"
                    endIcon={<PlayArrowIcon/>}
            >
                Начать
            </Button>

            <Divider sx={{margin: "16px 0"}}/>
            <Typography variant="body1" color="text.secondary" sx={{fontSize: 11}}>
                Нажимая кнопку "Начать", вы подтверждаете, что прочитали,<br/>
                поняли и согласны с условиями
                &nbsp;<Link target={"_blank"} href={"https://mathem.org/doc/terms.pdf"} color="text.secondary">Настоящего
                Соглашения.</Link>
            </Typography>
        </Paper>
    )
}
